export default ({ startTime, endTime }) => {
  const currentTime = Date.now();
  const startAt = new Date(startTime).getTime();
  const endAt = new Date(endTime).getTime();

  return currentTime >= startAt && currentTime <= endAt;
};
